import React from 'react';
import { Cog, Award, Users, Factory, Calendar, MapPin } from 'lucide-react';
import { aboutData, facilityData, images } from '../data/mock';

const AboutSection = () => {
  const features = [
    {
      icon: Factory,
      title: 'In-House Manufacturing',
      text: 'All products manufactured in our state-of-the-art facility'
    },
    {
      icon: Cog,
      title: 'Advanced Technology',
      text: 'Modern equipment ensuring precision and consistency'
    },
    {
      icon: Users,
      title: 'Skilled Workforce',
      text: 'Experienced team with specialized training'
    },
    {
      icon: Award,
      title: 'Quality Certified',
      text: 'Strict adherence to quality management standards'
    }
  ];

  return (
    <section id="about" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="section-header" style={{ marginBottom: '32px' }}>
              <p className="section-label">About Us</p>
              <h2 className="section-title">A Legacy of Precision Excellence</h2>
            </div>
            
            <p className="body-large mb-6">
              With over 45 years of manufacturing excellence, Fixwell Private Limited has established 
              itself as a leading manufacturer of high-quality fastening solutions for India's top brands.
            </p>
            <p className="body-regular mb-8">
              Our precision-engineered components are trusted by OEMs and Tier-1 suppliers across 
              industries. From our modern facility, we deliver over one million pieces daily.
            </p>

            {/* Facility info */}
            <div className="flex flex-wrap gap-6 mb-8 p-6" style={{ background: 'var(--bg-secondary)' }}>
              <div className="flex items-center gap-3">
                <MapPin size={18} style={{ color: 'var(--accent-teal)' }} />
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {facilityData.location}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Calendar size={18} style={{ color: 'var(--accent-teal)' }} />
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  Est. {facilityData.commercial_production_started_year}
                </span>
              </div>
            </div>

            {/* Customer names */}
            <div className="flex flex-wrap gap-4">
              {aboutData.named_customers.map((customer, index) => (
                <span 
                  key={index}
                  className="body-small px-3 py-1"
                  style={{ 
                    color: 'var(--text-light)',
                    background: 'var(--bg-secondary)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontSize: '11px'
                  }}
                >
                  {customer}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div className="image-overlay-container mb-6" style={{ height: '280px' }}>
              <img 
                src={images.factory}
                alt={images.factoryAlt}
                className="img-cover"
                loading="lazy"
              />
              <div className="image-overlay" />
            </div>
            <div className="about-features">
              {features.map((feature, index) => (
                <div key={index} className="about-feature">
                  <feature.icon className="about-feature-icon" />
                  <h4 className="about-feature-title">{feature.title}</h4>
                  <p className="about-feature-text">{feature.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
